import { HomeMarketBonusListTO, HomeMarketBonusTO } from '../app/core/interfaces/home-market-bonus.interface';
import { delay, http, HttpResponse } from 'msw';
import { hmbData } from './hmb-data';
import { Definition } from '../app/core/store/definitions/definition.interface';

const hmbMockData:HomeMarketBonusTO[] = hmbData.map(record => {
  return {
    senderShipTo: record.sender.id,
    senderNameShipTo: record.sender.name,
    senderRole: record.senderRole,
    receiverShipTo: record.receiver.id,
    receiverNameShipTo: record.receiver.name,
    receiverRole: record.receiverRole,
    activeFrom: record.activeFrom,
    activeTo: record.activeTo,
    isActive: record.isActive,
  }
});

if (typeof window['mocks'] === 'undefined') {
  window['mocks'] = [];
}

function getPropertyValue(record: HomeMarketBonusTO, propertyName: 'sender' | 'receiver' | 'activeFrom' | 'activeTo' | 'receiverRole' | 'senderRole') {
  switch (propertyName){
    case "sender":
      return record.senderNameShipTo.toLowerCase();
    case "receiver":
      return record.receiverNameShipTo.toLowerCase();
    case "activeFrom":
      return record.activeFrom;
    case "activeTo":
      return record.activeTo || new Date('2030-01-01').toISOString();
    case "receiverRole":
      return (record.receiverRole || '').toLowerCase();
    case "senderRole":
      return (record.senderRole || '').toLowerCase();

  }
}

window['mocks'].push(
  http.get('api/HomeMarketBonus', async ({request}) => {
    const url = new URL(request.url);
    const filter = {
       receiverRoles: url.searchParams.getAll('receiverRoles').map(role => role.toLowerCase()),
       senderShipToIds: url.searchParams.getAll('senderShipToIds'),
       receiverShipToIds: url.searchParams.getAll('receiverShipToIds'),
       active: url.searchParams.get('active') === 'true',
       pageSize: parseInt(url.searchParams.get('pageSize') || '99999', 10),
       pageNumber: parseInt(url.searchParams.get('pageNumber') || '0', 10),
    }
    const sorting = {
      sortKey: (url.searchParams.get('sortKey') || 'sender') as 'sender' | 'receiver' | 'activeFrom' | 'activeTo' | 'receiverRole' | 'senderRole',
      sortOrder: url.searchParams.get('sortOrder') || 'ASC',
    }

    const filtered = hmbMockData
      .filter(rec => filter.active === rec.isActive)
      .filter(rec => !filter.receiverRoles.length || filter.receiverRoles.find(role => rec.receiverRole?.toLowerCase().startsWith(role)))
      .filter(rec => !filter.senderShipToIds.length || filter.senderShipToIds.find(id => rec.senderShipTo === id))
      .filter(rec => !filter.receiverShipToIds.length || filter.receiverShipToIds.find(id => rec.receiverShipTo === id))

    // sorting
    filtered.sort((r1, r2) => {
      const v1 = getPropertyValue(r1, sorting.sortKey);
      const v2 = getPropertyValue(r2, sorting.sortKey);
      let result = v1 > v2 ? 1 : v1 < v2 ? -1 : 0;
      if (sorting.sortOrder !== 'ASC') {
        result = result * (-1);
      }
      return result;
    });

    const paged = filtered.slice(filter.pageNumber * filter.pageSize, filter.pageSize * (filter.pageNumber + 1));

    const result: HomeMarketBonusListTO = {
      totalCount: filtered.length,
      data: paged
    }
    await delay(500);
    return HttpResponse.json(result);
  }),
  http.get('api/HomeMarketBonus/shipTos', async () => {
    const senderShipTos: Definition[] = [];
    const receiverShipTos: Definition[] = [];
    hmbMockData.forEach(record => {
      if (!senderShipTos.find(st => st.id === record.senderShipTo)) {
        senderShipTos.push({id: record.senderShipTo, name: record.senderNameShipTo});
      }
      if (!receiverShipTos.find(st => st.id === record.receiverShipTo)) {
        receiverShipTos.push({id: record.receiverShipTo, name: record.receiverNameShipTo});
      }
    })
    await delay(500);
    return HttpResponse.json({senderShipTos, receiverShipTos});
  }),
  http.get('api/HomeMarketBonus/asDocument', async () => {
    const buffer = await fetch('/mocks/invoices.xlsx').then(response => response.arrayBuffer());
    await delay(1000);
    return HttpResponse.arrayBuffer(buffer, {
      headers: {
        'Content-Type':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
    })

  })
);
